import axios from 'axios';
import settings from './settings';

const xhrApi = axios.create({
	baseURL: settings.api + '/api',
});

export default xhrApi;
